import { FC } from 'react';
import useStyles from './styles';

const Separator: FC = () => {
  const css = useStyles();

  return <div className={css.separator} />;
};

export default Separator;
